var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg895",
    viewBox: "0 0 640 395.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs879"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style877",
    type: "text/css"
  }, ".e{fill:#f79e1b}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rect887",
    display: "inline",
    fill: "#ff5f00",
    strokeWidth: 5.494,
    d: "M224.833 42.298h190.416v311.005H224.833z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path889",
    d: "M244.446 197.828a197.448 197.448 0 0175.54-155.475 197.777 197.777 0 100 311.004 197.448 197.448 0 01-75.54-155.53z",
    fill: "#eb001b",
    strokeWidth: 5.494
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path891",
    d: "M621.101 320.394v-6.372h2.747v-1.319h-6.537v1.319h2.582v6.373zm12.691 0v-7.69h-1.978l-2.307 5.493-2.308-5.494h-1.977v7.691h1.428v-5.823l2.143 5h1.483l2.143-5v5.823z",
    className: "e",
    fill: "#f79e1b",
    strokeWidth: 5.494
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path893",
    d: "M640 197.828a197.777 197.777 0 01-320.015 155.474 197.777 197.777 0 000-311.004A197.777 197.777 0 01640 197.773z",
    className: "e",
    fill: "#f79e1b",
    strokeWidth: 5.494
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.72b81875c00a591e82aaed06cc707d65.svg";
export { ForwardRef as ReactComponent };